import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Button,
  Box,
  TextField,
} from "@mui/material";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import { useUser } from "../Contexts/UserContext";
import ExcelReader from "./ExcelReader";
import BackendExcelTable from "./BackendExcelTable";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const useStyles = makeStyles(() => ({
  tableContainer: {
    maxHeight: 400,
    overflow: "auto",
  },
  table: {
    minWidth: 650,
  },
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#eee",
    color: "#000",
  },
  rowCell: {
    padding: 1,
  },
  checkbox: {
    color: "#eee",
  },
  updateButton: {
    marginTop: 2,
    backgroundColor: "#4CAF50",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#45a049",
    },
  },
  searchField: {
    marginBottom: "1rem", // Add some margin to the search field
  },
}));

const MaterialsExcelPage = () => {
  const { user } = useUser();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [barData, setBarData] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  const { ClientId, CompCode } = user;

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file || barData.length < 5) {
      setError("Please select a file or enter graph data before submitting.");
      return;
    }

    // Prepare the form data
    const formData = new FormData();
    formData.append("file", file);
    formData.append("graphData", barData);
    formData.append("clientCode", ClientId);
    formData.append("page", "MaterialsReport");

    try {
      // Make the API call
      const response = await axios.post(
        `${API_URL}/adv/ReplaceExcelFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage(response.data.message);
      setError(""); // Clear any previous errors
    } catch (err) {
      setError(
        err.response?.data?.message || "An error occurred while uploading."
      );
      setMessage(""); // Clear any previous success messages
    }
  };

  // Handle form submission
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!file || barData.length < 5) {
  //     setError("Please select a file or enter graph data before submitting.");
  //     return;
  //   }

  //   // Prepare the form data
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("graphData", barData);

  //   try {
  //     // Make the API call
  //     const response = await axios.post(
  //       "http://125.63.103.94:90/api/adv/ReplaceExcelFile",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     setMessage(response.data.message);
  //     setError(""); // Clear any previous errors
  //   } catch (err) {
  //     setError(
  //       err.response?.data?.message || "An error occurred while uploading."
  //     );
  //     setMessage(""); // Clear any previous success messages
  //   }
  // };

  const handleCheckboxChange = (Id) => {
    const updatedData = data.map((unit) => {
      if (unit.Id === Id) {
        return { ...unit, IsChecked: !unit.IsChecked };
      }
      return unit;
    });
    setData(updatedData);
  };

  const postData = async (data) => {
    try {
      const response = await fetch(
        `${API_URL}/facility/GET_POST_In_ERP_Table/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ clientCode: ClientId, data }),
        }
      );

      const result = await response.json();
      if (result.success) {
        alert("Update successful :)");
      } else {
        alert("Something went wrong :(");
      }
    } catch (error) {
      console.error("Error posting data:", error);
      alert("Something went wrong :(");
    }
  };

  const handleUpdate = () => {
    const newCheckedUnits = data.filter(
      (unit) =>
        unit.IsChecked &&
        !originalData.some(
          (origUnit) =>
            origUnit.UnitCode === unit.UnitCode && origUnit.IsChecked
        )
    );

    const removedCheckedUnits = originalData.filter(
      (unit) =>
        !unit.IsChecked &&
        data.some(
          (newUnit) => newUnit.UnitCode === unit.UnitCode && newUnit.IsChecked
        )
    );
    postData(newCheckedUnits);
  };

  useEffect(() => {
    const getInitData = async () => {
      const response = await fetch(
        `${API_URL}/facility/GetRepairMaintenanceData/3/${CompCode}/${ClientId}/UNTAPS009482`
      ).then((res) => res.json());
      if (response.success) {
        setData(response.data);
        setOriginalData(response.data);
      } else {
        console.log("ERROR in making API Call");
        return;
      }
    };
    getInitData();
  }, []);

  const filteredData = data.filter(
    (unit) =>
      unit.UnitCode.toLowerCase().includes(searchQuery.toLowerCase()) ||
      unit.UnitName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleGetExcel = async () => {
    try {
      // Fetch the file as a Blob (binary data)
      const response = await fetch(
        `${API_URL}/adv/GetDownloadExcelSheet/${ClientId}/MaterialsReport`
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      // Convert the response to a Blob (binary data)
      const blob = await response.blob();

      // Create an anchor element to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob); // Create a URL for the Blob
      link.download = "Materials.xlsx"; // Specify the filename for the download
      link.click(); // Trigger the download
    } catch (err) {
      console.log("Error fetching Excel:", err);
    }
  };

  return (
    <>
      <div
        style={{
          padding: "2rem 4rem",
          width: "100%",
        }}
      >
        <h2
          className="heading2"
          style={{
            fontSize: "14px",
            fontWeight: "500",
            padding: "0",
            lineHeight: "1px",
            margin: "0px 0px 10px 0vw",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#aaaaaa",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Materials Delivery Status
          <style>
            {`
      .heading2::after {
        content: "";
    width: 120px;
    height: 1px;
    display: inline-block;
    background: #D10101;
    margin: 4px 10px;
      }
    `}
          </style>
        </h2>
        <Button onClick={handleGetExcel}>Download</Button>
        <div>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "10px", display: "inline-block" }}>
              <label htmlFor="fileInput">Upload</label>
              <input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                accept=".xlsx"
                style={{ marginLeft: "10px" }}
              />
            </div>
            <div style={{ marginBottom: "10px", display: "inline-block" }}>
              <textarea
                type="text"
                id="fileInput"
                placeholder="Label1 : value1,Label2: value2 .. X5"
                onChange={(e) => setBarData(e.target.value)}
                style={{
                  marginLeft: "10px",
                  width: "300px", // Adjust width as needed
                  height: "1.5em", // Keeps it to a single line

                  overflow: "hidden", // Hides extra text
                  whiteSpace: "nowrap", // Prevents wrapping
                }}
              />
            </div>
            <button type="submit">Submit</button>
          </form>
          {message && <p style={{ color: "green" }}>{message}</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
        <Box
          sx={{
            // overflow: "hidden",
            overflow: "scroll",
            height: "500px",
          }}
        >
          {/* <ExcelReader /> */}
          <BackendExcelTable page={`MaterialsReport`} />
        </Box>
      </div>
    </>
  );
};

export default MaterialsExcelPage;
